import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import React from 'react';
import './CertificationPopup.scss';

interface CertificationPopupProps {
  productTitle?: string;
  name: string;
  description: string;
  urls: string[];
  source: string;
  sourceTitle: string;
  type: string;
  sku: string;
  files?: any;
}

export default function CertificationPopup(props: CertificationPopupProps): React.ReactElement {
  const { urls, name, type, source, sourceTitle, description, files, productTitle } = props;
  const downloadZip = async () => {
    const zip = new JSZip();
    console.log('props', props);
    try {
      if (!files) {
        await Promise.all(
          urls.map(async (url) => {
            if (url) {
              try {
                const response = await fetch(url);
                if (!response.ok) {
                  throw new Error(`Failed to fetch ${url}: ${response.statusText}`);
                }
                const blob = await response.blob();
                zip.file(url.split('/').pop() || 'file', blob);
              } catch (error) {
                console.error(`Error fetching ${url}:`, error);
              }
            }
          })
        );
      } else {
        await Promise.all(
          files.map(async (fileContent) => {
            try {
              let basePath = typeof window !== 'undefined' ? window.location.origin + '/' : process.env.GATSBY_URL;
              const response = await fetch(basePath + fileContent.url);
              if (!response.ok) {
                throw new Error(`Failed to fetch ${fileContent.url}: ${response.statusText}`);
              }
              const blob = await response.blob();
              const fileName = fileContent.url.split('/').pop() || 'file';
              zip.file(fileName, blob);
            } catch (error) {
              console.error(`Error fetching ${fileContent.url}:`, error);
            }
          })
        );
      }

      const content = await zip.generateAsync({ type: 'blob' });
      saveAs(content, productTitle ? `${productTitle} ${name} certifications.zip` : `${name} certifications.zip`);
    } catch (error) {
      console.error('An error occurred during the zip creation process:', error);
    }
  };

  const formatDescription = (text) => {
    return text.replace(/^([\w\s']+:)/gm, '<strong>$1</strong>');
  };

  return (
    <div className="certifications-popup">
      <div>
        <span className="certifications-popup__info">
          <h2 className="certifications-popup__title">{type}</h2>
        </span>
        <div className="certifications-popup__description">
          <pre dangerouslySetInnerHTML={{ __html: formatDescription(description) }}></pre>
        </div>
      </div>
      <div className="certifications-popup__actions">
        <button onClick={downloadZip} className="certifications-popup__cta">
          DOWNLOAD
        </button>
        <a href={source} className="certifications-popup__link">
          Source: {sourceTitle}
        </a>
      </div>
    </div>
  );
}
